<template>
  <div class="template-container">
    <div class="container" @click="open = true">
      i
    </div>
    <div class="msg-box" :class="{hide: !open}">
      <p>Voulez vous reporter un bug ?</p>
      <div class="d-flex justify-content-around">
        <router-link to="/ticket-demande">
          <button @click="open = false">Oui</button>
        </router-link>
        <button @click.self.prevent="open = false">Non</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DeclareBug",
    data() {
      return {
        open: false
      };
    }
  }
</script>

<style scoped>
  .template-container {
    position: fixed;
    bottom: 12px;
    right: 12px;
    width: 2em;
    height: 2em;
    z-index: 1000;
  }

  .container {
    position: fixed;
    bottom: 12px;
    right: 12px;
    width: 2em;
    height: 2em;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: white;
    box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.6);
    transition: all ease 230ms;
    z-index: 1000;
    padding: 0;
  }

    .container:hover {
      box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.4);
      cursor: pointer;
    }

  .msg-box {
    position: absolute;
    bottom: calc(100% + 24px);
    right: 0;
    background-color: white;
    padding: 1em 2em;
    width: 15em;
    text-align: center;
    box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.6);
    border-radius: 6px;
  }

    .msg-box.hide {
      display: none;
    }

    .msg-box::after {
      display: block;
      content: "";
      position: absolute;
      bottom: -7px;
      right: 10px;
      width: 20px;
      height: 20px;
      background-color: white;
      transform: rotate(45deg);
    }

    .msg-box:hover {
      cursor: initial;
    }
</style>



// WEBPACK FOOTER //
// src/components/DeclareBug.vue